/** @jsx jsx */
import { jsx, Flex } from "theme-ui";
import { Link } from "gatsby";

import ThemeSwitcher from "./ThemeSwitcher";

interface HeaderProps {
  siteTitle?: string;
  children: MyReactNode;
}
const Header: React.FC<HeaderProps> = ({ siteTitle = "A Blog", children }) => {
  return (
    <header sx={{ bg: "header" }}>
      <Flex
        as="nav"
        sx={{
          variant: "heading",
          alignItems: "center",
          color: "primary",
          py: 4,
          px: [4, 5],
          fontVariantLigatures: "common-ligatures contextual",
          fontFeatureSettings: '"kern", "liga", "clig", "calt", "swsh"',
          fontKerning: "normal",
        }}
      >
        <Link
          to="/"
          sx={{
            variant: "links.ui",
            fontSize: 4,
            fontStyle: "italic",
            color: "inherit",
          }}
        >
          {siteTitle}
        </Link>
        <ThemeSwitcher sx={{ ml: "auto" }} />
      </Flex>
      {children}
    </header>
  );
};

export default Header;
